import {default as _ } from 'lodash';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { APIURL } from '../../../Shared/Constant/API_Urls';
import { GridService } from '../../../Shared/Services/grid.service';
import { UserService } from '../../../Shared/Services/user.service';
import {default as CAT_ORDER} from 'app/Shared/Constant/Grid Column Names/Orders-Columns.json';
import {default as CAT_TRADE} from 'app/Shared/Constant/Grid Column Names/Trades-Columns.json';
import {default as CAT_ROUTE} from 'app/Shared/Constant/Grid Column Names/Routes-Columns.json';
import {default as CAT_ALLOCATION} from 'app/Shared/Constant/Grid Column Names/Allocation-Columns.json';
import {default as CAT_ACT_TRADE} from 'app/Shared/Constant/Grid Column Names/ACT-Trades-Columns.json';
import {default as GridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/Client-Data-Exception-Columns.json';
import {default as AggoOrderColumnsJSON} from 'app/Shared/Constant/Grid Column Names/AGGO-Columns.json';
import {default as TDETColumnsJSON} from 'app/Shared/Constant/Grid Column Names/TDET-Columns.json';
import {default as Timecombo} from 'app/Shared/Constant/TimeDropDown.json';
import { SharedHttpClientService } from '../../../Shared/Services/shared-http-client.service';
import { UrlsService } from '../../../Shared/Services/urls.service';
import { ConfirmationService,MessageService} from 'primeng/api';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { ActivatedRoute } from '@angular/router';
import { DatePipe, LowerCasePipe, NgClass, NgFor, CommonModule, NgStyle } from '@angular/common';
import { DataService } from 'app/Shared/Services/data.service';
import { Util } from '../../../Shared/Constant/Util';
import { Table, TableModule} from 'primeng/table';
import { Subscription } from 'rxjs';
import { ConstantService } from 'app/Shared/Services/constant-service';
import {generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { map } from 'rxjs/operators';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ExportToCSVSComponent } from 'app/Shared/Component/export-to-csv/export-to-csv.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MassCorrectionComponent } from 'app/Shared/Component/mass-correction/mass-correction.component';
import { MatDividerModule } from '@angular/material/divider';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule} from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import { Select } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { DrawerModule } from 'primeng/drawer';
import { GridCommonService } from 'app/Shared/Services/grid-common.service';
import { ContextMenu, ContextMenuModule } from 'primeng/contextmenu';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-cats-exception',
    imports: [CommonModule, FilterPanelComponent, MatProgressSpinner, ConfirmDialogModule, TableModule,ContextMenuModule,
        NgClass, ToastModule, ExportToCSVSComponent, LowerCasePipe, MatTooltipModule, Select, MassCorrectionComponent,ButtonModule,
        DrawerModule, MatDividerModule, DialogModule, MultiSelectModule, FormsModule, NgStyle, DatePickerModule],
    templateUrl: './client-data-exception.component.html',
    styleUrls: ['./client-data-exception.component.scss']
})
export class ClientDataExceptionComponent implements OnInit,OnDestroy {

  @ViewChild(('dt')) dt!: Table;
  @ViewChild('cm') contextMenuItems!: ContextMenu;
  GridColumns = GridColumnsJSON["ClientDataGridColumns"];
  dataset1: any[] = [];
  exceptionsMap: any[] = [];
  errorcodesMap: any[] = [];
  format:any="";
  ActiveSymbol: any;
  ClientExecutionDate!: any[];
  SymbolsArray: any = [];
  CodesArray: any = [];
  DefaultFilterArray: any = [];
  filters: any = [];
  isFilterLabelReset: boolean = false;
  isResetGridlimit: boolean = false;
  isLoadingResults = true;
  tbldatamsg = "L o a d i n g . . . . ."; 
  Limit: any = { 'Start': '', 'End': '' };
  totalRecords: any;
  columnJson: any = [];
  cols: any = []
  filterCols: any = []
  rowsPerPageOptions: any = [];
  rowcount: number = 17;
  startLimit: any = 0;
  endLimit!: number;
  priviousRowCount!: number;
  pageNumber: any = 1;
  priviousStartLimit: any;
  View: boolean = false;
  Edit: boolean = false;
  displayDialog: boolean = false;
  Editviewcols: any = [];
  selectedRow: any = [];
  quickviewcols: any = [];
  EventType!: string;
  ResetLabel!: string;
  selectedRowLength!: number;
  selectedRowIndex: any;
  MultiEdit!: boolean;
  tempDataset: any = [];
  MultiEditRow: any = [];
  selectedRowJSONDataset: any[] = [];
  selectedRowOriginalJSON: { [key: string]: any }[] = [];
  msgs!: any[];
  FromDate: any = "";
  ExceptionCode: any = '';
  EditHeaderTittle!: string;
  CATFieldTypesArrayList: any = [];
  aggoOrdersCols: any;
  aggoOrdersData: any;
  handlingInstructionCols: any;
  handlingInstructionData: any
  tradeSideDetailsCols: any;
  tradeSideDetailsData: any;
  BooleanDropDown: any = [{
    label: "true", value: true, description: "True"
  },
  {
    label: "false", value: false, description: "False"
  }];
  TimeDropDown: any;
  newLabel!: string;
  handlingInstructionObj: {} | null = {}
  timeInForceObj = {}
  handleInstIndex!: number;
  timeIndex!: number;
  isClickedOnce: boolean = false;
  previousLimit:  any = { 'Start': '', 'End': '' };
  sortData:any = { field: '', order: 0};
  sortClickCounter: number = 0;
  defaultData: any;
  massCorrectionFields: any[] = [];
  private subscription!: Subscription;

  constructor(
    private UrlsService: UrlsService,
    public UserService: UserService,
    public constantService:ConstantService,
    private SharedHttpClientService: SharedHttpClientService,
    private gridService: GridService,
    private emitterService: EmitterService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private activatedRoute: ActivatedRoute,
    private sortPipe: SortPipe,
    private datePipe: DatePipe,
    public commonColService:GridCommonService) {
    this.aggoOrdersCols = AggoOrderColumnsJSON;
    this.aggoOrdersData = [];
    this.tradeSideDetailsCols = TDETColumnsJSON;
    this.handlingInstructionCols = this.UserService.handlingInstructionsJSON;
    this.tradeSideDetailsData = [];
    this.getFieldDictionary();
  }

  ngOnInit(): void {
    this.rowsPerPageOptions=this.constantService.DEFAULT_ROWSPERPAGEOPTION;
    this.rowcount = this.constantService.DEFAULT_ROWSIZE;
    this.endLimit = this.rowcount;
    this.Limit = { 'Start': '0', 'End': this.endLimit };
    this.totalRecords = this.rowcount;
    this.FromDate=this.UserService.LastClientReportDate;
    this.ClientExecutionDate = [];
    this.ClientExecutionDate[0] = this.FromDate;// Fromdate
    this.ClientExecutionDate[1] = this.FromDate;// Todate
    /*** Get Last CLient Execution date*/
    this.ClientExecutionDate[0] = this.FromDate;// Fromdate
    this.ClientExecutionDate[1] = this.FromDate;// Todate
    
    //MD call then update date
    let mdDate = this.activatedRoute.snapshot.paramMap.get('Date');
    this.ExceptionCode = this.activatedRoute.snapshot.paramMap.get('Code');
    if(Util.isDefinedAndNotNull(mdDate)) {
      if (mdDate == 'Null' || mdDate == 'NULL' ) {
        const today = new Date();
        // Get 30 days back date from current date
        const thirtyDaysAgo = new Date(today.setDate(today.getDate() - 30));
        this.ClientExecutionDate[0] = thirtyDaysAgo ;// Fromdate
        this.ClientExecutionDate[1] = new Date();// Todate
      } else {
        this.ClientExecutionDate[0] = mdDate// Fromdate
        this.ClientExecutionDate[1] = mdDate// Todate
      }
    }
    
    this.defaultFilter();
    this.getColumns();
    this.getAggoOrdersColumns();
    this.getTDETColumns();

    this.dataset1 = [];
    this.TimeDropDown = Timecombo;
   this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getData();
      }
    });
   this.commonColService.init(this.cols, 'Client-Data-Exception');
  }

  getRowCount() {
    const height = $(window).innerHeight();
    this.rowcount = height !== undefined ? height : 0; 
    this.rowcount = this.gridService.getGridRowsCount();
    if (this.rowcount < 15)
      this.rowcount = 15;
    this.endLimit = this.rowcount;
  }
  getColumns() {
    let column: any = this.GridColumns;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.columnJson = this.gridService.getGridColumns(column);
      this.cols = this.gridService.getGridColumns(column);
      this.filterCols = this.cols;
    }
  }

  getAggoOrdersColumns() {
    let column: any = this.aggoOrdersCols;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.aggoOrdersCols = this.gridService.getGridColumns(column);
    }
  }

  getTDETColumns() {
    let column: any = this.tradeSideDetailsCols;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.tradeSideDetailsCols = this.gridService.getGridColumns(column);
    }
  }

  onRowSelect(value: any, index: any, rowData: any) {
    this.isClickedOnce = false;
    if (this.selectedRow.length <= 1) {
      this.selectedRow = [];
      this.selectedRow[0] = (rowData)
    }
    if (value == 'View') {
      this.getCATEditOriginalJSON(value, index, rowData);
    } else if (value == 'Edit') {
      this.getCATEditOriginalJSON(value, index, rowData);
    } else if (value == 'Delete') {
      this.deleteSelectedRows();
    } else if (value == 'RestoreDeleted') {
      this.restoreDeleteSelectedRows();
    }
    if (value == 'OrderID') {
      this.emitterService.isOrderViewerOpenCloseEvent.emit(
        {
          display: true,
          rowData: rowData,
          pageName: 'CAT-Exception'
        });
    }
  }

  prepareJsonData(value: any, index: any, rowData: any) {
    this.selectedRowLength = Object.keys(this.selectedRow).length;
    if (this.selectedRowLength <= 1) {
      this.selectedRow = [];
      this.selectedRow[0] = (rowData)
    }
    this.selectedRowLength = Object.keys(this.selectedRow).length;
    this.quickviewcols = [];
    this.aggoOrdersData = [
      {
        'orderID': rowData.orderID,
        'orderKeyDate': rowData.orderKeyDate,
        'quantity': rowData.quantity,
        'originatingIMID': rowData.originatingIMID
      }
    ];
    this.tradeSideDetailsData = [
      {
        'orderKeyDate': rowData.orderKeyDate,
        'orderID': rowData.orderID,
        'side': rowData.side,
        'quantity': rowData.quantity,
        'firmDesignatedID': rowData.firmDesignatedID,
        'accountHolderType': rowData.accountHolderType,
        'originatingIMID': rowData.originatingIMID
      }
    ];
    let tempRow: any = this.selectedRow[0];
    this.EventType = '';
    this.EventType = tempRow.type;
    this.prepareQuickviewPanel();
    if (this.selectedRowLength == 1) // Single select row
    {
      if (value === 'Edit') {
        this.Edit = true;
      } else if (value === 'View') {
        this.View = true
      }

      let flag = tempRow.modifiedFlag;
      let ExceptionCode = tempRow.failureCode;
      if (this.EventType != "--" && this.EventType != "" && this.EventType != " " && this.EventType != null) {
        this.Editviewcols = [];

        this.tempDataset = this.cloneData(this.selectedRowJSONDataset[0]);/* *** set old data for backup */
        if (value == 'OrderID') {
          this.emitterService.isOrderViewerOpenCloseEvent.emit(
            {
              display: true,
              rowData: rowData,
              pageName: 'CAT-Exception'
            });
        }
        this.displayDialog = true;
      } else {
        if (value == 'View') {
          this.View = true;
        } else {
          let msginfo = 'Flag=' + flag;
          if (this.EventType == "--" || this.EventType == "" || this.EventType == " " || this.EventType == null)
            msginfo = 'Event Type=' + this.EventType;
          if (flag == 'D')
            msginfo = 'Flag=' + flag;
          this.messageService.add({ severity: 'warn', summary: 'Info Message', detail: 'Selected record is non editable please check ' + msginfo });
          this.displayDialog = false;
        }
      }
    }
    else if (this.selectedRowLength > 1) // multiselect rows
    {

      if (value == 'Edit') {
        this.MultiEditRow = [];
        this.validateMultiEdit(rowData);
      }
    }
  }
  getValueofField(fieldName: string) {
    if (this.View) {
      if (fieldName === 'buyDetails' || fieldName === 'sellDetails' || fieldName === 'clientDetails' || fieldName === 'firmDetails' || fieldName === 'timeInForce' ||fieldName === 'handlingInstructions') {
        return JSON.stringify(this.selectedRowJSONDataset[0][fieldName]);
      }
      }
     if (fieldName === 'handlingInstructions') {
      let obj = this.selectedRowJSONDataset[0][fieldName]
      let result = obj!== undefined? Object.keys(obj).map(function (key) {
        return [(key), obj[key]];
      }): [];
      this.selectedRowJSONDataset[0][fieldName] = this.selectedRowJSONDataset[0][fieldName] !==undefined ? [this.selectedRowJSONDataset[0][fieldName]] : [{}];
      this.handlingInstructionCols = this.gridService.getGridColumnsHasValues(result);
      return  this.selectedRowJSONDataset[0][fieldName];
    } else if (fieldName === 'reportDate' || fieldName === 'rsmsStatus' || fieldName === 'groupName') {
      if (fieldName === 'rsmsStatus') {
        return this.selectedRow[0].modifiedFlag
      } else {
        return this.selectedRow[0][fieldName];
      }
    } else {
      return this.selectedRowJSONDataset[0][fieldName];
    }

  }
  isFiledDisable(fieldName: string) {
    if (fieldName === 'reportDate' || fieldName === 'rsmsStatus' || fieldName === 'groupName' || fieldName === 'type'
      || fieldName === 'firmROEID' || fieldName === 'CATReporterIMID') {
      return true
    } else {
      return false
    }
  }
  cloneData(tempRow: any, action?: string) {
    this.timeInForceObj = tempRow ? tempRow.timeInForce : null;
    this.handlingInstructionObj = tempRow && tempRow.handlingInstructions !== null && tempRow.handlingInstructions !== "" && tempRow.handlingInstructions !== undefined? JSON.stringify(tempRow.handlingInstructions) : null;
    this.Editviewcols = [];
    let len = Object.keys(this.quickviewcols).length;
    let FailureDescription = "";
    for (let i = 0; i < Object.keys(this.quickviewcols).length; i++) {
      let tempKeyName = this.quickviewcols[i].mappingkey;
      let isError = false;
      if (Util.isDefinedAndNotNull(tempKeyName)) {
        let error_code_object: any;
        error_code_object = this.UserService.getFieldDictionaryObject(tempKeyName);
        if (error_code_object) {
          let keyofValue = error_code_object["field_Name"];
          this.quickviewcols[i].datatype = error_code_object['data_Type'];
          this.Editviewcols[i] =
            {
              "ui_Field_Name": error_code_object["ui_Field_Name"],
              "field_Name": error_code_object["field_Name"],
              "default_Value": error_code_object["default_Value"],
              "value": this.getValueofField(keyofValue),
              "datatype": this.quickviewcols[i].datatype,
              "time": "00:00:00",
              "display": this.quickviewcols[i].display,
              "db_columnname": this.quickviewcols[i].db_columnname,
              "dropdowntype": error_code_object["dropdowntype"],
              "dropdownvalue": error_code_object.dropdownvalue,
              "description": error_code_object["description"],
              "error_Code": error_code_object["error_Code"],
              "error_Code_Description": error_code_object["error_Code_Description"],
              "isException": isError,
              "isDisable": this.isFiledDisable(keyofValue),
              "maxlength": this.quickviewcols[i].maxlength,
              "precision": this.quickviewcols[i].precision,
              "scale": this.quickviewcols[i].scale
            }
          let datatype: string = error_code_object["data_Type"];
          if (datatype == 'Choice') {
            this.Editviewcols[i].datatype = "Choice";
          }
        }
        else {
          this.Editviewcols[i] =
            {
              "ui_Field_Name": this.quickviewcols[i].ui_columnname,
              "field_Name": this.quickviewcols[i].mappingkey,
              "default_Value": "",
              "value": this.getValueofField(this.quickviewcols[i].mappingkey),
              "datatype": this.quickviewcols[i].datatype,
              "time": "00:00:00",
              "display": this.quickviewcols[i].display,
              "db_columnname": this.quickviewcols[i].db_columnname,
              "dropdowntype": this.quickviewcols[i].dropdown,
              "dropdownvalue": this.quickviewcols[i].dropdownvalue,
              "description": "",
              "error_Code": "",
              "error_Code_Description": "",
              "isException": isError,
              "isDisable": this.isFiledDisable(this.quickviewcols[i].mappingkey),
              "maxlength": this.quickviewcols[i].maxlength,
              "precision": this.quickviewcols[i].precision,
              "scale": this.quickviewcols[i].scale
            }
        }
      }
      if (action === 'mutiedit') {
        this.Editviewcols[i]['value'] = null;
      }
    }
    return this.Editviewcols;
  }

  validateActTradeFields(): boolean {
    if (this.EventType?.toUpperCase() !== 'ACT_TRADE') {
      return true;
    }
    let isValid = true;
    this.Editviewcols.forEach((element: { value: any; maxlength: any; precision: any; scale: any; ui_Field_Name: string; isInvalid?: boolean; errorMessage?: string; }) => {
      element.isInvalid = false;
      element.errorMessage = '';
      if (element?.value === null || element?.value === undefined || typeof element.value === 'object') {
        return;
      }
      let value = String(element.value).trim();
      if (value === '') {
        return;
      }
      let maxlength = Number(element.maxlength);
      if (maxlength > 0 && value.length > maxlength) {
        isValid = false;
        element.isInvalid = true;
        element.errorMessage = 'Maximum length is ' + maxlength + ' characters';
      }
      let precision = Number(element.precision);
      let scale = Number(element.scale) || 0;
      if (precision > 0) {
        let parts = value.match(/^[-+]?(\d*)(?:\.(\d*))?$/);
        let integerDigits = parts ? parts[1].replace(/^0+/, '').length : 0;
        let decimalDigits = parts && parts[2] ? parts[2].length : 0;
        if (!parts || (parts[1] === '' && !parts[2]) || integerDigits > precision - scale || decimalDigits > scale) {
          isValid = false;
          element.isInvalid = true;
          element.errorMessage = parts && (parts[1] !== '' || parts[2]) ? 'Maximum ' + (precision - scale) + ' digits and ' + scale + ' decimals allowed' : 'Please enter a valid number';
        }
      }
    });
    return isValid;
  }

  save() {
    if (!this.validateActTradeFields()) {
      return;
    }
    this.isClickedOnce = true;
    this.Editviewcols.filter((element: { field_Name: string; }, index: string | number) => {
      if(element.field_Name === 'handlingInstructions') {
        this.handlingInstructionData =  this.Editviewcols[index].value;
        this.Editviewcols[index].value = {};
        let  handlingArr= [];
        let handlingObj: any
        this.handlingInstructionCols.forEach((element: { header: string; }) => {
         let  keys = Object.keys(this.handlingInstructionData[0]);
         if(JSON.stringify(this.handlingInstructionData[0]) !== JSON.stringify({}) && keys.indexOf(element.header) >= 0)
         {
          handlingArr.push({[element.header]:this.handlingInstructionData[0][element.header]})
          handlingObj = Object.assign({}, ...handlingArr); // Array of obj into one obj
         }
        });
        this.Editviewcols[index].value = this.handlingInstructionCols.length>0 && handlingObj!== undefined ?this.removeNullValueObj(handlingObj): null;
      }
    })
    let tempRow = this.selectedRow[0];
    this.updateDataValidation(tempRow);
    this.CallUpadteAPI();
    this.selectedRow = [];
    this.displayDialog = false;
    this.newLabel = '';
    this.handlingInstructionObj = {};
    this.timeInForceObj = {};
  }

  resetDefault() {
    let tempRow = this.selectedRowJSONDataset[0];
    this.cloneData(tempRow);
  }

  updateDataValidation(tempRow: any) {
    for (let i = 0; i < Object.keys(this.quickviewcols).length; i++) {
      let tempRow = this.selectedRow[0];
      this.Editviewcols

    }
  }
  singleEditFormateDatetime(datatype: string, type: string, i: string | number) {
    if (type == 'date') {
      let temp: string = this.datePipe.transform(this.Editviewcols[i].value, "yyyy-MM-dd") ?? "";
      let date: string = ((temp.replace("-", "")).replace("-", "")).replace("-", "");
      if (datatype == "DateTime") {
        let temptime: string = this.Editviewcols[i].time;
        if (temptime == undefined) {
          this.Editviewcols[i].value = date.concat("000000000");
        } else {
          let time: string = ((temptime.replace(":", "")).replace(":", "")).replace(":", "");
          this.Editviewcols[i].value = date.concat(time);
        }
      }
      else if (datatype == "Date" || datatype == "DateRange") {
        this.Editviewcols[i].value = date.concat("000000000");
      }
    } if (type == 'time') {
      let temp: string = this.Editviewcols[i].value;
      let date: string = temp.substring(0, 8);
      let temptime: string = this.Editviewcols[i].time;
      let time: string = ((temptime.replace(":", "")).replace(":", "")).replace(":", "");
      this.Editviewcols[i].value = date.concat(time);
    }
  }

  formatTime(value: string, i: string | number) {
    let temp: string = this.MultiEditRow[i].value;
    let date: string = temp.substring(0, 8);
    let temptime: string = value;
    let time: string = ((temptime.replace(":", "")).replace(":", "")).replace(":", "");
    this.MultiEditRow[i].value = date.concat(time);
  }
  formatDate(datatype: string, i: string | number) {
    let temp: string = this.datePipe.transform(this.MultiEditRow[i].value, "yyyy-MM-dd") ?? "";
    let date: string = ((temp.replace("-", "")).replace("-", "")).replace("-", "");
    if (datatype == "DateTime") {
      let temptime: string = this.MultiEditRow[i].time;
      if (temptime == undefined) {
        this.MultiEditRow[i].value = date.concat("000000000");
      } else {
        let time: string = ((temptime.replace(":", "")).replace(":", "")).replace(":", "");
        this.MultiEditRow[i].value = date.concat(time);
      }
    }
    else if (datatype == "Date" || datatype == "DateRange") {
      this.MultiEditRow[i].value = date.concat("000000000");
    }
  }
  getCATEditOriginalJSON(value: any, index: any, rowData: any) {
    this.selectedRowOriginalJSON = JSON.parse(rowData.originalJSON.replace(/'/g, '"'));
    this.selectedRowJSONDataset[0] = this.selectedRowOriginalJSON;
    let Data = {
      "mpid": this.UserService.getActiveMPID(),
      "groupName": rowData['groupName'],
      'reportDate': rowData['reportDate'],
      'firmROEID': rowData['firmROEID'],
      'pageName': "CAT-Exception",
      'eventType': rowData['type'],
      "fileID": this.selectedRow[0].fileID != null ? this.selectedRow[0].fileID  : 0,
    };
    this.prepareJsonData(value, index, rowData);
    this.SharedHttpClientService.post(this.UrlsService.setAPIURl(APIURL.CLIENT_Exception_Get_OriginalJSON), Data)
      .pipe((response: any) => {
        return response;
      }).subscribe({
        next: (dataset:any) => {

        let data: any = dataset;

        if (data.Data.length > 0) {
          this.selectedRowJSONDataset[0] = JSON.parse((data.Data[0].json).replace(/'/g, '"'));
          this.selectedRowOriginalJSON =this.selectedRowJSONDataset[0];
          this.format = this.selectedRowJSONDataset[0]["format"];
        }
        this.prepareJsonData(value, index, rowData);
      },error: (err: HttpErrorResponse) => {
          this.prepareJsonData(value, index, rowData);
      }});
  }

  CallUpadteAPI() {
    /* *** Update API Call */
    let object: any = {};
    let tempRow = this.selectedRowJSONDataset[0]
    this.Editviewcols.forEach((element: { value: string | null; field_Name: string | number; }, index: string | number) => {
      if (element.value !== null && element.value !== "" && element.value !== undefined) {
        object[element.field_Name] = this.Editviewcols[index].value;
        tempRow[element.field_Name] = this.Editviewcols[index].value;
      }
    });

    Object.keys(this.selectedRowOriginalJSON).map(key => {
      let matchingString = "rsmsStatus,firmROEID,type,reportDate,groupName,oMSSystem".toLowerCase();
      if(object[key]==undefined && matchingString.indexOf(key.toLowerCase())<0)
      {
        object[key] = this.selectedRowOriginalJSON[key as keyof typeof this.selectedRowOriginalJSON];
      }
     });

    let Data = {
      "P_OriginalJSON": JSON.stringify(this.selectedRowOriginalJSON) + "",
      "P_UpdatedJSON": JSON.stringify(object) + "",
      "P_User": this.UserService.getUserName(),
    }
    this.SharedHttpClientService.postPlainText(this.UrlsService.setAPIURl(APIURL.CLIENT_Exception_Summary_Update), Data)
      .pipe(map((response: string) => {
        return response;
      }))
      .subscribe({
        next: (Element:any) => {
        let data: any = Element;
        if (data == "Update Failed")
          this.messageService.add({ severity: 'error', summary: 'Update Failed Message', detail: 'Record Update Failed!' });
        if (data == "Updated Successfully") {
          tempRow = this.selectedRowOriginalJSON;
          tempRow['modifiedFlag'] = 'U';
          // tempRow['status'] = 'Close';
          this.selectedRow[0] = tempRow;
          this.tempDataset = [];
          this.dt.reset();// reset data table
          // this.selectedRow = [];
          this.Edit = false;
          this.isClickedOnce = false;
          this.handlingInstructionData = [];
          this.messageService.add({ severity: 'success', summary: 'Update Success Message', detail: 'Record Update Successfully' });
        }
        this.Edit = false;
        this.timeIndex = -1;
        this.getData();
      },
      error: (err: HttpErrorResponse) => {
          this.messageService.add({ severity: 'error', summary: 'Update', detail: 'Record Update Failed!' });
          this.isClickedOnce = false;
      }});
  }

  CallDeleteAPI(Data: { P_selectedRows: any; P_Updated_By: any; }) {
    /* *** Delete API Call */
    this.SharedHttpClientService.postPlainText(this.UrlsService.setAPIURl(APIURL.CLIENT_Exception_Summary_Delete), Data)
    .pipe(map((response: string) => {
      return response;
    }))
      .subscribe({
        next: (Element:any) => {
        let data: any = Element;
        if (data == "Delete failed.")
          this.messageService.add({ severity: 'error', summary: 'Delete Message', detail: 'Deleted Failed' });
        if (data == "Deleted Successfully") {
          this.getData();
          this.messageService.add({ severity: 'success', summary: 'Delete Message', detail: 'Records are Deleted Successfully ' });
        }
      },
        error: (err: HttpErrorResponse) => {
          this.messageService.add({ severity: 'error', summary: 'Delete Message', detail: 'Deleted Failed' });
      }});

  }
  CallRestoreDeleteAPI(Data: { P_selectedRows: any; P_Updated_By: any; }, rowdata: any[], tempRow: { [x: string]: string; }, index: number) {
    /* *** Delete API Call */
    this.SharedHttpClientService.postPlainText(this.UrlsService.setAPIURl(APIURL.CAT_Exception_Summary_RestoreDelete), Data)
    .pipe(map((response: string) => {
      return response;
    }))
      .subscribe({
        next: (Element:any) => {
        let data: any = Element;
        if (data == "Restore Deleted record failed.")
          this.messageService.add({ severity: 'error', summary: 'Delete Message', detail: 'Restore Deleted Failed' });
        if (data == "Restore Deleted Successfully") {
          tempRow['modifiedFlag'] = 'N';
          tempRow['status'] = 'Open';
          this.selectedRow[index] = tempRow;
          this.tempDataset = [];
          this.getData();
          if(this.selectedRow.length === index) {
            this.messageService.add({ severity: 'success', summary: 'Delete Message', detail: 'Records are Restore Successfully ' });
          }
          this.selectedRow = [];
        }
      },
        error: (err: HttpErrorResponse) => {
          this.messageService.add({ severity: 'error', summary: 'Delete Message', detail: 'Restore Deleted Failed' });
      }});

  }

  deleteSelectedRows() {
    let msg = '';
    if (this.selectedRow.length > 1)
      msg = 'Are you sure you want to remove all exceptions?';
    else
      msg = 'Are you sure you want to remove this exception?';
    this.confirmationService.confirm({
      message: msg,
      icon: 'pi pi-exclamation-triangle',
      header: 'Confirmation',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      defaultFocus: 'reject',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button",

      accept: () => {
        this.isLoadingResults = true
        let Data = {
          'P_selectedRows': this.selectedRow,
          "P_Updated_By": this.UserService.getUserName(),
        };
        this.CallDeleteAPI(Data);
      }
    });
    this.displayDialog = false;
    this.msgs = [];
  }

  restoreDeleteSelectedRows() {
    let msg = '';
    if (this.selectedRow.length > 1)
      msg = 'Are you sure that you want to Restore DELETED All?';
    else
      msg = 'Are you sure that you want to Restore DELETED?';
    this.confirmationService.confirm({
      message: msg,
      accept: () => {
        this.isLoadingResults = true
        let tempRow;
        let Data;
        let rowdata = [...this.dataset1];

        for (let i = 0; i < this.selectedRow.length; i++) {
          tempRow = this.selectedRow[i];
          let eventType = tempRow.type;
          let flag = tempRow.modifiedFlag;
          let ExceptionCode = tempRow.failureCode;
          if (eventType != "--" && eventType != "" && eventType != " " && eventType != null) {
            Data = {
              "P_selectedRows": this.selectedRow,
              "P_Updated_By": this.UserService.getUserName()
            };
            this.CallRestoreDeleteAPI(Data, rowdata, tempRow, i);
          }
          else {
            let msginfo = 'Flag=' + flag;
            if (flag == 'D')
              msginfo = 'Flag=' + flag;
            this.messageService.add({ severity: 'error', summary: 'Delete Message', detail: 'Deleted Failed! ' });
            this.displayDialog = false;
          }
        }
      }
    });
    this.displayDialog = false;
    this.msgs = [];
  }
  validateMultiEdit(rowData: any) {
    let correctCodeLength: number = 0
    this.selectedRow.forEach((row: { type: any; failureCode: any; }) => {
      if (this.selectedRow[0].type === row.type && this.selectedRow[0].failureCode === row.failureCode) {
        correctCodeLength = correctCodeLength + 1
      } else {
        correctCodeLength = correctCodeLength - 1
      }
    });

    if (this.selectedRow.length === correctCodeLength) {
      this.selectedRow = [];
      this.Editviewcols = []
      this.selectedRow[0] = rowData;
      this.cloneData(this.selectedRow[0], 'mutiedit')
      this.Edit = true
    } else {
      this.Edit = false
      this.messageService.add({ severity: 'error', summary: 'Delete Message', detail: 'event type and failure code should be same' });
      // alert('event type and failure code should be same');

    }
  }
  lookupRowStyleClass(rowData: { [x: string]: string; }) {
    if (rowData['modifiedFlag'] === 'U')
      return rowData['modifiedFlag'] === 'U' ? 'ui-widget-updated-row' : 'ui-widget-NoUpdated-row';
    else if (rowData['modifiedFlag'] === 'D')
      return rowData['modifiedFlag'] === 'D' ? 'ui-widget-deleted-row .ui-chkbox ' : 'ui-widget-NoUpdated-row';

    return "";
  }
  prepareQuickviewPanel() {
    this.quickviewcols = [];
    switch (this.EventType.toLocaleUpperCase()) {
      case 'ORDER':
        this.quickviewcols = CAT_ORDER["Orders-Grid-Columns"];
        break;
      case 'TRADE':
        this.quickviewcols = CAT_TRADE["Trades-Grid-Columns"];
        break;
      case 'ROUTE':
        this.quickviewcols = CAT_ROUTE["Routes-Grid-Columns"];
        break;
      case "ACT_TRADE":
        this.quickviewcols = CAT_ACT_TRADE["Act-Trades-Grid-Columns"];
        break;
      default: {
        // statements;
        break;
      }
    }
  }

  changePage(event: { first: any; rows: number; }) {
    this.startLimit = event.first;
    this.endLimit = this.startLimit + this.rowcount;
    this.rowcount = event.rows;

    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.priviousStartLimit = this.startLimit;
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;

    this.getData();
  }

  FilterEventClearSymbol(event: any) {
    this.isResetGridlimit = true;
    this.startLimit = 0;
    this.Limit.Start = 0;

    this.pageNumber = 1;
    this.dt.first = this.startLimit;
    this.emitterService.ResetQuickFilterPanelEvent.emit("Symbol");
  }

  FilterEventClearCode(event: any) {
    this.isResetGridlimit = true;
    this.startLimit = 0;
    this.Limit.Start = 0;

    this.pageNumber = 1;
    this.dt.first = this.startLimit;
    this.emitterService.ResetQuickFilterPanelEvent.emit("Code");
  }

  FilterApplyFilterEvent(event: any) {
    this.isResetGridlimit = true;
    this.DefaultFilterArray = [];
    this.DefaultFilterArray = event;
    this.startLimit = 0;
    this.Limit.Start = 0;

    this.pageNumber = 1;
    this.dt.first = this.startLimit;
    this.getData();
  }


  setActiveSymbolEvent(event: any) {
    this.ActiveSymbol = event;
    for (let i = 0; i < this.DefaultFilterArray.length; i++) {
      if (this.DefaultFilterArray[i].label.toLocaleLowerCase() == 'symbol') {
        this.DefaultFilterArray[i].values = this.ActiveSymbol;
        this.startLimit = 0;
        this.Limit.Start = 0;
        this.totalRecords = 0;
        this.pageNumber = 1;
        this.dt.first = this.startLimit;
        this.emitterService.ReloadQuickFilterPanelEvent.emit("true");
        this.getData();
      }
    }
  }

  setActiveCodeEvent(event: any) {
    let ActiveCode: number = event;
    for (let i = 0; i < this.DefaultFilterArray.length; i++) {
      if ((this.DefaultFilterArray[i].label).toLocaleLowerCase() == 'code') {
        this.DefaultFilterArray[i].values = ActiveCode;
        this.startLimit = 0;
        this.Limit.Start = 0;

        this.pageNumber = 1;
        this.dt.first = this.startLimit;
        this.emitterService.ReloadQuickFilterPanelEvent.emit("true");
        this.getData();
      }
    }
  }

  CloseEvent(event: any) {
    this.View = false;
    this.Edit = false;
    this.MultiEdit = false;
  }

  GridResetSymbolEvent(event: any) {
    this.isFilterLabelReset = true;
    this.startLimit = 0;
    ;
    this.Limit.Start = 0;
    this.pageNumber = 1;
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.dt.first = this.startLimit;
    this.isResetGridlimit = true;
    this.emitterService.ResetQuickFilterPanelEvent.emit('All');
  }

  GridChangeLimitEvent(event: any) {
    this.Limit = event;
    this.getData();
  }

  defaultFilter() {
    /*update date if its calling from dashboard */
    this.DefaultFilterArray = [
      /* { 'isdefault': 'true', 'label': 'Date', 'columnname': 'eventTimestamp', 'filterby': '', 'values': this.ClientExecutionDate, 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' }, */
      { 'isdefault': 'true', 'label': 'Date', 'columnname': 'reportDate', 'filterby': '', 'values': this.ClientExecutionDate, 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'type', 'columnname': 'type', 'filterby': 'IS', 'values': ['ORDER', 'TRADE', 'ROUTE', 'ALLOCATION', 'ACT_TRADE'], 'time': '', 'datatype': 'skip', 'disabled': 'true', 'dropdown': 'YES', 'dropdowntype': 'multiselect', 'dropdownvalue': this.getFilterType() },
      { 'isdefault': 'true', 'label': 'Event Type', 'columnname': 'eventType', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Symbol', 'columnname': 'symbol', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Code', 'columnname': 'failureCode', 'filterby': '=', 'values': this.ExceptionCode, 'time': '', 'datatype': 'int', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Group', 'columnname': 'groupName', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'File Name', 'columnname': 'fileName', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Firm ROEID', 'columnname': 'firmROEID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' }
    ];
    this.getData();
    
  }
  getFilterType() {
    return [{
      "label":"ORDER",
      "isActive":true,
      "isDefault":null,
      "sequenceNo":0,
      "description":"Order File Details",
      "value":"ORDER"
   },
   {
      "label":"ROUTE",
      "isActive":true,
      "isDefault":null,
      "sequenceNo":0,
      "description":"Route File Details",
      "value":"ROUTE"
   },
   {
      "label":"TRADE",
      "isActive":true,
      "isDefault":null,
      "sequenceNo":0,
      "description":"Trade File Details",
      "value":"TRADE"
   },
   {
    "label":"ALLOCATION",
    "isActive":true,
    "isDefault":null,
    "sequenceNo":0,
    "description":"Allocation File Details",
    "value":"ALLOCATION"
 },
{
    "label":"ACT TRADE",
    "isActive":true,
    "isDefault":null,
    "sequenceNo":0,
    "description":"ACT TRADE File Details",
    "value":"ACT_TRADE"
 }]
  }

  getFieldDictionary() {
    this.CATFieldTypesArrayList = this.UserService.getDropDownList('type');
  }

  getData() {
    this.dataset1 = [];
    this.selectedRow = [];
    this.isLoadingResults = true;
    this.previousLimit = this.Limit;
    this.tbldatamsg = "L o a d i n g . . . . .";
    this.gridService.getData(
      APIURL.CLIENT_Exception,
      this.DefaultFilterArray,
      this.Limit,
      this.gridService.getEventsList(this.DefaultFilterArray, 'type'),
      "CAT-Exception"
    ).subscribe({
      next: (Element:any) => {
      this.isLoadingResults = false;
      let dataset: any = Element;
      this.dataset1 = dataset.Data;
      this.defaultData = this.dataset1;
      this.dataset1.map((item)=>{
        if(this.exceptionsMap[item.firmROEID]!=null && this.exceptionsMap[item.firmROEID].indexOf(item.failureDescription)<0)
        {
          this.exceptionsMap[item.firmROEID] = this.exceptionsMap[item.firmROEID]+", \n"+item.failureDescription;
        }else{
          this.exceptionsMap[item.firmROEID] =item.failureDescription;
        }

        if(this.errorcodesMap[item.firmROEID]!=null && this.errorcodesMap[item.firmROEID].indexOf(item.failureCode)<0)
        {
          this.errorcodesMap[item.firmROEID] = this.errorcodesMap[item.firmROEID]+", \n"+item.failureCode;
        }else{
          this.errorcodesMap[item.firmROEID] =item.failureCode;
        }
        item["parentOrderID"]=JSON.parse(item.originalJSON).parentOrderID;
        item["orderKeyDate"]= JSON.parse(item.originalJSON).orderDate;
        item["timeInForce"]= JSON.parse(item.originalJSON).timeInForce;
      });
      
      
      this.isResetGridlimit = false;
      this.totalRecords = dataset.totalCount;
      this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);

      if (this.dataset1.length == 0) {
        this.tbldatamsg = "No data found";
      }
    }, error: (err: HttpErrorResponse) => {
      this.isLoadingResults = false;
      this.tbldatamsg = 'No data found';
      this.totalRecords = 0;
      this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
    }});
    this.isFilterLabelReset = false;
    this.isResetGridlimit = false;
  }


  setEditRowValue(index: number, key: string) {
    this.Editviewcols[index].value = {
      [key]: '',
    }
  }
  getObjectKey(obj: {}) {
    const key = Object.keys((obj))[0];
    return key;
  }

  removeNullValueObj(obj: { [x: string]: any; }) {
    Object.keys(obj).forEach((key) => {
      if (obj[key] === "" || obj[key] === null) {
        delete obj[key]
      }
    })
    return obj
  }
  exportToCSV(event: { isExportMaxRows: any; gridColumn: any; }) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    if(event.isExportMaxRows) {
      this.Limit ={ 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS };
    } else {
      this.Limit = this.previousLimit;
    }
    this.gridService.getData(
      APIURL.CLIENT_Exception,
      this.DefaultFilterArray,
      this.Limit,
      this.gridService.getEventsList(this.DefaultFilterArray, 'type'),
      "CAT-Exception"
    ).subscribe({
      next: (Element:any) => {
      this.isLoadingResults = false;
      let dataset: any = Element;
      let data = dataset.Data;
      if(data.length > 0) {
        data.forEach((col: { [x: string]: any; originalJSON?: string; }) => {
          col["parentOrderID"] = col.originalJSON !== undefined ? JSON.parse(col.originalJSON).parentOrderID : "";
          col["orderKeyDate"] = col.originalJSON !== undefined ? JSON.parse(col.originalJSON).orderDateTime : "";
          col["timeInForce"] = col.originalJSON !== undefined ? JSON.parse(col.originalJSON).timeInForce : "";
           
          delete col.originalJSON;
        });
        const options : any = { 
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true, 
          showTitle: true,
          title: 'RSMS_Client_Data_Exception_'+ this.UserService.getyyyyMMddDateFormate(new Date()),
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          // header: ['col 1', 'col 2'] // Won't work with useKeysAsHeaders present!
          filename: this.UserService.getActiveMPID() +'_RSMS_Client_Data_Exception_'+ this.UserService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
        };
        const csvData = this.constantService.getExportData(data, event.gridColumn);
        const csv = generateCsv(options)(csvData);
        const blob = asBlob(options)(csv);
        saveAs(blob,options.filename);
        this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
        this.UserService.logUserActivity('Export CSV', null, {
          'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
        this.UserService.logUserActivity('Export CSV', null, {
          'Text1': 'No data found',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
      this.emitterService.exportToCSVData.emit(true);
    }, error: (err: HttpErrorResponse) => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
      this.UserService.logUserActivity('Export CSV', null, {
        'Text1': 'Error while Exporting',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    }});
  }
  sort(event: { multisortmeta: {order: number; field: any;}[]; }) {
    if (this.commonColService.isCtrlPressed|| this.commonColService.isDragging || this.commonColService.selectedFields.length > 1) {
    this.dt.multiSortMeta =[];
    this.dt.sortField = '';
    this.dt.sortOrder = 0;
    return;
  }
    if(this.sortClickCounter !== 3 &&(this.sortData.field === "" ||this.sortData.field === event.multisortmeta[0].field)) {
      this.sortClickCounter = this.sortClickCounter + 1;
    } else {
      this.sortClickCounter = 1;
    } 
    if(this.sortClickCounter !== 3) {
      let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
      this.sortData.field = event.multisortmeta[0].field;
      this.sortData.order = sortOrder;
      this.dataset1 = this.sortPipe.transform(this.dataset1, this.sortData.order, this.sortData.field);
    } else {
    this.resetSort()
    }
    
  }
  resetSort() {
    if(this.dt.multiSortMeta != undefined && this.dt.multiSortMeta?.length > 0) {
      this.dt.multiSortMeta[0].field = '';
      this.dt.multiSortMeta[0].order = 0;
    }
    
    this.dataset1 = this.defaultData;
  }

  get isMassCorrectionDisabled(): boolean {
    if (this.selectedRow?.length > 0) {
      return this.selectedRow.some((record: { type: string; }) => record.type?.toUpperCase() === 'ACT_TRADE');
    }
    let typeFilter = this.DefaultFilterArray?.find((row: { columnname: string; }) => row.columnname === 'type');
    return typeFilter?.values?.length === 1 && typeFilter.values[0]?.toUpperCase() === 'ACT_TRADE';
  }

  get massCorrectionTooltip(): string {
    return this.isMassCorrectionDisabled ? 'Mass Correction is not available for ACT TRADE records' : 'Mass Correction';
  }

  checkRecordTypes() {
    if(this.selectedRow.length > 0) {
      if(this.selectedRow.map((record: { type: any; }) => record.type).every((row: string) => (row.toLocaleLowerCase() === this.selectedRow[0].type.toLocaleLowerCase()))) {
        this.prepareMassCorrectionFields(this.selectedRow[0].type.toLocaleLowerCase()); // Prepare Mass Correction Fields
        
        // Prepare Filters to displaynon Mass Correction Popup
        this.filters = [];
        this.filters = _.cloneDeep(this.DefaultFilterArray);
        let typeIndex = this.filters.findIndex((row: { columnname: string; }) => row.columnname==='type');
        if(typeIndex > 0) {
          this.filters[typeIndex]['values'] = [this.selectedRow[0].type];
        }

        return true;
      } else {
        this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: "Please select same type of selected records" });
      }
    } else if(this.selectedRow.length === 0) {
      let typeIndex = this.DefaultFilterArray.findIndex((row: { columnname: string; }) => row.columnname==='type');

      if(this.DefaultFilterArray[typeIndex]['values'].length!==1) {
        this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: "Please select single type for Mass Correction" });
      } else if(this.DefaultFilterArray[typeIndex]['values'].length===1) {
        this.prepareMassCorrectionFields(this.dataset1[0].type.toLocaleLowerCase()); // Prepare Mass Correction Fields

        // Prepare Filters to displaynon Mass Correction Popup
        this.filters = [];
        this.filters = _.cloneDeep(this.DefaultFilterArray);

        return true;
      }
    } else {
      this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: "Please select any record" });
      return false;
    }

    return false;
  }

  onShowMassCorrectionScreen() {
    this.UserService.showMassCorrection = true;
  }

  prepareMassCorrectionFields(rowType: any) {
    this.quickviewcols = [];
    this.massCorrectionFields = [];

    switch(rowType) {
      case "order":
        this.quickviewcols = CAT_ORDER;
        this.massCorrectionFields = _.sortBy(GridColumnsJSON["MassCorrectionOrderFieldList"], "ui_columnname");
      break;
      case "route":
        this.quickviewcols = CAT_ROUTE;
        this.massCorrectionFields = _.sortBy(GridColumnsJSON["MassCorrectionRouteFieldList"], "ui_columnname");
      break;
      case "trade":
        this.quickviewcols = CAT_TRADE;
        this.massCorrectionFields = _.sortBy(GridColumnsJSON["MassCorrectionTradeFieldList"], "ui_columnname");
      break;
      case "allocation":
        this.quickviewcols = CAT_ALLOCATION;
        this.massCorrectionFields = _.sortBy(GridColumnsJSON["MassCorrectionAllocationFieldList"], "ui_columnname");
      break;
    }
  }

  updateMassCorrectedField(payload: any) {
    this.isLoadingResults = true;
    this.UserService.showMassCorrection = false;

    if(this.selectedRow.length > 0) {
      // Receiving Selected Row Ids
      let rowIds = this.selectedRow.map((row: { rowID: any; }) => row.rowID);
      payload['rowIds'] = rowIds;
    }

    // Receiving Row Type (Order/Route/Trade/Allocation)
    let typeIndex = this.filters.findIndex((row: { columnname: string; }) => row.columnname==='type');
    payload['exceptionTypes'] = this.filters[typeIndex]['values'].map((item: string) => "'" + item + "'").join(", ");

      this.SharedHttpClientService.post(
        this.UrlsService.setAPIURl(
          APIURL.CLIENT_Exception_Mass_Correction_Update
        ), payload
      ).subscribe({
        next: (Element:any) => {
          let dataset: any = Element;
          if (dataset.status) {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: "Mass Correction Succeeded" });
            this.UserService.logUserActivity('Mass Correction', null, {
              'Text1': 'Mass Correction performed successfully | User Filters: ' + this.getFilterDetails(payload),
              'Text2': 'User Filter Parameters: ' + this.getFilterParametes(this.filters)
            });
            this.getData(); // Retrieve fresh Data
          } else {
            this.isLoadingResults = false;
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'Mass Correction Failed' });
            this.UserService.logUserActivity('Mass Correction', null, {
              'Text1': 'Error while performing Mass Correction | User Filters: ' + this.getFilterDetails(payload),
              'Text2': 'User Filter Parameters: ' + this.getFilterParametes(this.filters)
            });
          }
        }}), (err: HttpErrorResponse) => {
          this.isLoadingResults = false;
          this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'Mass Correction Failed' });
          this.UserService.logUserActivity('Mass Correction', null, {
            'Text1': 'Error while performing Mass Correction | User Filters: ' + this.getFilterDetails(payload),
            'Text2': 'User Filter Parameters: ' + this.getFilterParametes(this.filters)
          });
      };

  }

  getFilterParametes(filterData: any) {
    let filterParam: any;
    if (filterData) {
      filterParam = filterData.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0));
      return JSON.stringify(filterParam);
    }
    return '';
  }

  getFilterDetails(payload: any) {
    let msg = '';

    for(let i=0; i < payload.massUpdatedFields.length; i++) {
      msg += (i > 0 ? ", " : "") + payload.massUpdatedFields[i]["filterField"] + ": " + payload.massUpdatedFields[i]["filterFieldValue"];
    }
    return msg;
  }

  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }
}
